"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
/**
 * Helper function that appends unique ids into each
 * object of the list in the parameter
 * @param list list of <T> that need ids
 */
function assignUid(list) {
    if (list.length < 1) {
        return [];
    }
    return list.map(function (ele) {
        var uid = lodash_uniqueid_1.default();
        return {
            id: uid,
            data: ele,
        };
    });
}
exports.default = assignUid;
//# sourceMappingURL=assignUid.js.map